import { STANDARD_BRANCH } from '@festina-life/api'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { useConfigurationComponentAvailability } from '../hooks/useConfigurationComponentAvailability'
import { server as serverPath } from '../system/paths'
import { useNavigationParams } from '../system/useNavigationParams'
import { useAllConciseBranches } from '../uiModels/branches/useAllConciseBranches'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { useWorkspaceManagerContext } from './workspaceManagerContext'

export const useNavigateToRootOnInvalidPath = () => {
  const navigate = useNavigate()
  const conciseBranches = useAllConciseBranches()
  const { currentWorkspaceKey } = useWorkspaceManagerContext()
  const workspace = useCurrentWorkspace()
  const { branch, server, layer, block } = useNavigationParams()
  const isConfigurationComponentAvailable =
    useConfigurationComponentAvailability()

  useEffect(() => {
    const isWorkspacePathInError =
      (currentWorkspaceKey && !workspace) ||
      (workspace && (workspace.baseBranchName ?? null) !== (branch ?? null))

    const isBranchPathInError =
      branch &&
      branch !== STANDARD_BRANCH &&
      !currentWorkspaceKey &&
      !conciseBranches[server]?.some(
        (specification) => specification.name === branch,
      )

    const isOnlyStandardComponentWithInvalidBranch =
      !isConfigurationComponentAvailable && branch && branch !== STANDARD_BRANCH

    if (
      isWorkspacePathInError ||
      isBranchPathInError ||
      isOnlyStandardComponentWithInvalidBranch
    ) {
      void navigate(
        serverPath({
          server,
          layer,
          block,
          branch: undefined,
          workspaceName: undefined,
        }),
      )
    }
  }, [
    branch,
    conciseBranches,
    isConfigurationComponentAvailable,
    navigate,
    server,
    workspace,
    currentWorkspaceKey,
    block,
    layer,
  ])
}
